/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/models/verfuegbarkeitsanfrage.ts.
 */
import {Artikel} from '../../../models/artikel';
import {ArtikelVerfuegbarkeit} from '../../../models/artikel-verfuegbarkeit';

/**
 * Zweck: Beschreibt class Verfuegbarkeitsanfrage und ihren Daten- oder Funktionsvertrag.
 */
export class Verfuegbarkeitsanfrage {
  artikel: Artikel;
  status: ArtikelVerfuegbarkeit;
}
